import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_KEY_ADMIN_CENTRAL } from './admin-central.reducer';

const getResourcesFromAppointment = (appState: any) => appState[STORE_FEATURE_KEY_ADMIN_CENTRAL].resources;

@Injectable()
export class AdminCentralSelectors {
    constructor(private store: Store<any>) {
    }
    selectGetResourcesFromAppointment(): Observable<any> {
        return this.store
            .pipe(select(getResourcesFromAppointment));
    }
}
